import { useCallback, useEffect, useRef, useState } from "react";
import { obterSegundosBloqueioLogin } from "../utils/loginUnificado.utils";

// ------------------------------- FUNCTIONS -------------------------------
export default function useBloqueioTentativasLogin() {
	// -------------------------------- STATES --------------------------------
	const prazoRef = useRef(0);
	const [bloqueadoAte, setBloqueadoAte] = useState(0);
	const [agora, setAgora] = useState(Date.now);

	// -------------------------------- EFFECTS -------------------------------
	useEffect(() => {
		if (bloqueadoAte <= Date.now()) return;
		const timer = globalThis.setInterval(() => {
			const horario = Date.now();
			setAgora(horario);
			if (horario >= bloqueadoAte) globalThis.clearInterval(timer);
		}, 250);
		return () => globalThis.clearInterval(timer);
	}, [bloqueadoAte]);

	// ----------------------------- DERIVED STATE ----------------------------
	const segundosRestantes = Math.max(0, Math.ceil((bloqueadoAte - agora) / 1000));

	// -------------------------------- HANDLERS ------------------------------
	const registrarErro = useCallback((error: unknown): void => {
		const segundos = obterSegundosBloqueioLogin(error);
		if (segundos === null) return;
		const horario = Date.now();
		prazoRef.current = Math.max(prazoRef.current, horario + segundos * 1000);
		setAgora(horario);
		setBloqueadoAte(prazoRef.current);
	}, []);

	function estaBloqueado(): boolean {
		return prazoRef.current > Date.now();
	}

	// -------------------------------- RETURN --------------------------------
	return { segundosRestantes, registrarErro, estaBloqueado };
}
